<template>
<div class="el-main">
  <div class="card" v-show="currentCardId == 'edu-history'">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>学歴を入力</h2>
        <p>「自動入力」を使うと、入学・卒業年度を自動で計算できます</p>
        <el-checkbox v-model="formatData.notDisplayIjyo">【以上】を表示しない</el-checkbox>
      </div>
      <div class="card-content-list">
        <div class="add-item">
          <div class="edu-history-action">
            <auto-educational-backgrounds v-on:create-educational-background="setEducationalBackgrounds"
                                          :year="basicData.birthYear"
                                          :month="basicData.birthMonth"
                                          :day="basicData.birthDay"></auto-educational-backgrounds>
            <div class="button-reset">
              <el-button v-if="formatData.educationalHistories && formatData.educationalHistories.length > 1"
                         @click="$modal.show('educational-reset')">リセット</el-button>
            </div>
            <modal name="educational-reset"
                   :adaptive="true"
                   :scrollable="true"
                   height="auto">
              <div class="v--modal-close-top">
                <el-button @click="$modal.hide('educational-reset');"
                           icon="el-icon-close"
                           type="text"></el-button>
              </div>
              <div class="title">学歴リセット</div>
              <span>入力されている学歴をすべて削除します。よろしいですか？</span>

              <div class="text-left">
                <el-button type="primary"
                           @click="$modal.hide('educational-reset');resetEducationalBackgrounds()">リセットする</el-button>
                <el-button @click="$modal.hide('educational-reset')">リセットしない</el-button>
              </div>
            </modal>

          </div>
        </div>
        <div class="edit-form-item" v-if="formatId == 'rirekisho_job_new' || formatId == 'rirekisho_job_new_single'">
          <div class="item-name">卒業予定</div>
          <div class="item-body">
            <el-select v-model="formatData.gradeYear"
              placeholder="選択してください">
              <el-option v-for="item in gradeYearOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </div>
        </div>
        <div class="edit-form-list">
          <transition-group name="fade"
                            tag="div">
            <history-item v-on:add-history-item="addEducationalHistory"
                          v-on:delete-history-item="deleteEducationalHistory"
                          v-on:move-history-item="moveEducationalHistory"
                          v-for="(item, index) in formatData.educationalHistories"
                          @click.native="activateHistoryItem(item.uuid)"
                          :item="item"
                          :length="formatData.educationalHistories.length"
                          :index="index"
                          :key="item.uuid"
                          :id="item.uuid"
                          :class="{'active': activeHistoryItem == item.uuid}"
                          :minYear="basicData.birthYear"
                          :ref="'EducationalHistory_' + index"
                          :createDate="formatData.createDate"
                          :descriptionPlaceholder="'学歴を入力'"
                          :descriptionMaxLength="descriptionMaxLength"></history-item>
          </transition-group>
          <div class="add-list-item">
            <el-button icon="el-icon-plus"
                       circle
                       type="success"
                       @click="addEducationalHistory()"></el-button>
          </div>
        </div>
        <div class="attention-limit column"
             v-if="previewErrors.eduJobHistory">
          <i class="el-icon-warning"></i> {{ previewErrors.eduJobHistory }}
        </div>
      </div>
    </div>
  </div>

  <div class="card" v-show="currentCardId == 'job-history'">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>職歴を入力</h2>
        <p>「自動入力」を使うと、入社・退社表記を自動で作成できます。</p>
      </div>

      <div class="card-content-list">
        <div class="edit-form-item">
          <div class="item-name">希望業界</div>
          <div class="item-body">
            <el-select v-model="formatData.hopeIndustry"
              placeholder="選択してください">
              <el-option v-for="item in hopeIndustryOptions"
                :key="item"
                :label="item"
                :style="item"
                :value="item"></el-option>
            </el-select>
          </div>
          <div class="item-name">希望職種</div>
          <div class="item-body">
            <el-select v-model="formatData.hopeJobcategory"
              placeholder="選択してください">
              <el-option v-for="item in hopeJobcategoryOptions"
                :key="item"
                :label="item"
                :style="item"
                :value="item"></el-option>
            </el-select>
          </div>
        </div>
        <div class="edit-form-list">
          <div class="add-item">
            <auto-job-histories v-on:job-histories-created="setJobHistories"
                                :birth-year="basicData.birthYear"
                                :birth-month="basicData.birthMonth"
                                :birth-day="basicData.birthDay"></auto-job-histories>
            <div class="button-reset">
              <el-button type=""
                         v-if="formatData.jobHistories && formatData.jobHistories.length > 1"
                         @click="$modal.show('job-reset')">リセット</el-button>
            </div>
            <modal name="job-reset"
                   :adaptive="true"
                   :scrollable="true"
                   height="auto">
              <div class="v--modal-close-top">
                <el-button @click="$modal.hide('job-reset');"
                           icon="el-icon-close"
                           type="text"></el-button>
              </div>
              <div class="title">職歴リセット</div>
              <span>現在入力されている職歴をすべて削除します。よろしいですか？</span>
              <div>
                <el-button type="primary"
                           @click="$modal.hide('job-reset');resetJobHistories()">リセットする</el-button>
                <el-button @click="$modal.hide('job-reset')">リセットしない</el-button>
              </div>
            </modal>
          </div>
          <transition-group name="fade"
                            tag="div">
            <history-item v-on:add-history-item="addJobHistory"
                          v-on:delete-history-item="deleteJobHistory"
                          v-on:move-history-item="moveJobHistory"
                          v-for="(item, index) in formatData.jobHistories"
                          @click.native="activateHistoryItem(item.uuid)"
                          :item="item"
                          :length="formatData.jobHistories.length"
                          :index="index"
                          :key="item.uuid"
                          :id="item.uuid"
                          :class="{'active': activeHistoryItem == item.uuid}"
                          :ref="'JobHistory_' + index"
                          :minYear="basicData.birthYear"
                          :createDate="formatData.createDate"
                          :descriptionPlaceholder="'職歴を入力'"
                          :descriptionMaxLength="descriptionMaxLength"></history-item>
          </transition-group>
          <div class="add-list-item">
            <el-button icon="el-icon-plus"
                       circle
                       type="success"
                       @click="addJobHistory()"></el-button>
          </div>
          <div class="attention-limit column"
               v-if="previewErrors.eduJobHistory">
            <i class="el-icon-warning"></i>&ensp;{{ previewErrors.eduJobHistory }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="card" v-show="currentCardId == 'complete'" >
    <download-item :formatId="formatId"
    :isSendYagiPostEnabled="isSendYagiPostEnabled"
    :isSendYagiEmailEnabled="isSendYagiEmailEnabled"
    :mailPdfEnabled="mailPdfEnabled"
    :downloadPdfEnabled="downloadPdfEnabled"
    :downloadActiveCollapses="downloadActiveCollapses"
    ></download-item>

  </div>

</div>
</template>
<style lang="scss" scoped>
.yagitaku{
  line-height: 25px;
  padding: 15px 0;
  font-weight: bold;
}
.yagitaku_recommend{
  color: #fff;
  background: #E3165C;
  padding: 5px 10px;
  margin-right: 5px;
  border-radius: 50px;
}
.yagitaku_link{
  color: #E3165C;
  border-bottom: 1px solid #E3165C;
}
.create-date_bnr{
  margin: 15px 0;
}

.el-button--success.overwrite.overwrite,
.el-button--primary.overwrite {
    color: #000;
    background: #EFF8F8;
    border: none;
    display: block;
    padding: 0;
    border-radius: 15px;
    white-space: normal;
    line-height: 1.8;
}

.el-button--success.overwrite.overwrite:hover,
 .el-button--primary.overwrite:hover{
    background: none;
    color: #000;
}
.addition {
  font-size: .75rem;
  margin: .5rem 0;
}

* {
	list-style: none;
	box-sizing: border-box;
	margin: 0;
	padding: 0;
}
img {
	width: 100%;
	vertical-align: bottom;
}
.next_bnr{
  font-size: 1rem;
  color: #004d40;
  text-align: center;
  padding: 1.2rem;
}
.bnr_container {
	display: flex;
	flex-wrap: wrap;
	margin: calc(-30px / 2);
	padding: 30px;
}
.bnr_itemWrapper {
	width: calc(100% / 2 - 30px);
	margin: calc(30px / 2);
}
.bnr_item {
  text-align: center;
}
.bnr_item img{
  border-radius: 10px 10px 0 0 ;
}
.bnr_txt{
  padding: 15px;
  background: #EFF8F8;
  border-radius: 0 0 10px 10px;
}
.txt{
  border-radius: 10px;
}
.bnr_txt p{
  font-size: 0.8rem;
  font-weight: bold;
}
.bnr_txt h3{
  color: #E3165C;
  font-size: 1.1rem;
  font-weight: bold;
}
.bnr_txt span{
  font-size: 0.8rem;
}
.create-date_txt {
  border-radius: 10px;
}
.bnr_note{
  font-size: 0.8rem;
}
.card-header h1{
  padding-bottom: 1.5rem;
}
.card-header h2{
  padding-bottom: 1.5rem;
}
/* タブレット　2カラム */
@media screen and (max-width: 1024px) {
	.bnr_itemWrapper {
		width: calc(100% / 2 - 30px);
	}
}
/* スマホ 1カラム*/
@media screen and (max-width: 599px) {
	.bnr_itemWrapper {
		width: calc(100% / 1 - 30px);
	}
}

</style>

<script>
import HistoryItem from './RirekishoParts/HistoryItem'
import DownloadItem from './CommonParts/YagiofferDownloadItem'
import AutoEducationalBackgrounds from './RirekishoParts/AutoEducationalBackgrounds'
import AutoJobHistories from './RirekishoParts/AutoJobHistories'
import LocalDataMixin from '@/mixins/local-data-mixin'
import LoginForms from '@/components/LoginSpecialForms'

const uuidv4 = function () {
  const cryptoObj = window.crypto || window.msCrypto
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
    (c ^ cryptoObj.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
  )
}
const HistoryData = function (year, month, description) {
  this.year = Number(year) || ''
  this.month = Number(month) || ''
  this.description = description || ''
  this.uuid = uuidv4()
}
export default {
  name: 'CareerYagiofferEdit',
  props: {
    basicData: {
      type: Object,
      require: true
    },
    formatId: {
      type: String
    },
    previewFormat: {
      type: Object,
      require: true
    },
    currentCardId: {
      type: String
    },
    exampleSentences: {
      type: Object
    }
  },
  mixins: [LocalDataMixin],
  components: {
    'history-item': HistoryItem,
    'download-item': DownloadItem,
    'auto-educational-backgrounds': AutoEducationalBackgrounds,
    'auto-job-histories': AutoJobHistories,
    'login-forms': LoginForms
  },
  data: function () {
    return {
      saveName: 'rirekisho',
      saveOtherName: 'shokumukeirekisho',
      activeName: '1',
      formatData: {
        createDate: null,
        educationalHistories: [],
        jobHistories: [],
        licenseHistories: [],
        commuteDescription: '',
        commuteHours: '',
        commuteMinutes: '',
        spouseNumber: '',
        hasSpouse: false,
        underDutyToSupport: false,
        reason: '',
        reasonNew: '',
        request: '',
        nowNensyu: '',
        kibouNensyu: ''
      },
      isWeekEndFlag: true,
      activeHistoryItem: '',
      educationalResetDialogVisible: false,
      jobResetDialogVisible: false,
      descriptionMaxLength: 80,
      mailPdfEnabled: true,
      downloadPdfEnabled: true,
      isSendYagiPostEnabled: true,
      isSendYagiEmailEnabled: true,
      previewScale: 1,
      previewViewerCss: {},
      isNew: false,
      textareaMinRows: 3,
      reasonLabel: '志望動機、特技、好きな学科、アピールポイントなど。書き方に困ったときは例文を元に編集してみましょう',
      downloadActiveCollapses: ['postcard'],
      hopeIndustryOptions: ['IT・通信', 'ソフトウェア・情報処理', 'インターネット関連・ゲーム・アプリ関連', '機械・産業用装置・電機・OA機器', '自動車・自動車部品・輸送用機器', 'コンピュータ・通信機器・精密機器', '電子部品・半導体', '食品・飲料・たばこ・飼料', '化学・医薬・化粧品', '鉄鋼・非鉄金属・金属製品', '石油・石炭・ゴム・プラスチック', 'ガラス・セラミック・セメント', 'パルプ・紙・紙加工・印刷・印刷関連', '日用品・文具・オフィス用品', '建材・エクステリア', 'インテリア・住宅関連', 'アパレル・服飾関連', 'スポーツ・玩具・ゲーム機器', 'その他メーカー・製造関連', '電気・ガス・石油・水道', '放送（テレビ・ラジオ含む）', '新聞・出版', '広告', 'その他（芸能・エンタテインメント関連等）', '運輸（鉄道・航空・海運・物流等）', '総合商社', '専門商社', '百貨店・スーパー・ドラッグストア・コンビニ・ホームセンター', '通信販売、専門店・その他小売り', '銀行（協同組織金融含む）', '証券', '保険', 'その他金融（クレジット等）', 'リース・レンタル', 'ディベロッパー', '建設・建築設計・ハウスメーカー', '設備関連', 'プラント・プラントエンジニアリング', '不動産取引・不動産賃貸・不動産管理', 'デザイン・芸術関連', 'コンサルティング・マーケティング・調査', 'その他専門・技術サービス', 'ホテル・旅館', '外食', 'その他フード', '理美容・エステ・フィットネスクラブ', '旅行・観光', '家事サービス・クリーニング', '冠婚葬祭', 'その他生活関連サービス', 'アミューズメント・レジャーサービス', '教育関連', '医療・保育・介護、福祉', '環境・リサイクル・廃棄物処理', '整備・修理', '人材サービス', 'その他事業サービス（警備、コールセンター等）', 'その他'],
      hopeJobcategoryOptions: ['営業', '事務・秘書・受付', '経理', '総務人事', 'バイヤー', '法務', '知的財産部門', '企画', 'マーケティング', '宣伝・広報', '経営企画', '経営コンサルタント', '為替ディーラー・トレーダー', '証券アナリスト', '融資・資産運用(ファンドマネージャー等）', 'ファイナンシャルアドバイザー', 'アクチュアリー', 'システムエンジニア・プログラマ', 'Webエンジニア', 'ネットワークエンジニア', 'セキュリティエンジニア', 'インフラ・データエンジニア', 'AIエンジニア', '組み込みエンジニア', 'カスタマーエンジニア', '社内SE・情シス', '研究職（製造系）', '設計開発', '生産・製造', '物流・在庫管理', 'セールスエンジニア', '品質管理', '医療技術', 'MR（医薬情報担当者）', '研究開発（医薬系）', '薬剤師', '栄養士', '福祉士・介護士・ホームヘルパー', '講師・インストラクター', '専門コンサルタント', '建築・土木設計', '施工管理', 'Webプロデューサー・ディレクター', 'Webデザイナー', 'デザイナー', 'ゲームクリエイター', 'ゲームプログラマ', 'データサイエンティスト・アナリスト', '記者・ライター', '編集・制作', '販売・接客', '店長（店舗経営・運営）', 'スーパーバイザー', '農業', '林業', '漁業'],
      gradeYearOptions: [
        {
          value: '23',
          label: '23年卒'
        },
        {
          value: '24',
          label: '24年卒'
        },
        {
          value: '99',
          label: 'その他'
        }
      ],
      fontOptions: [
        {
          value: "font-family: 'Noto Sans JP', sans-serif;",
          label: 'Noto Sans JP'
        },
        {
          value: "font-family: 'Noto Serif JP', serif;",
          label: 'Noto Serif JP'
        },
        {
          value: "font-family: 'Zen Maru Gothic', sans-serif;",
          label: 'yagishゴシック'
        },
        {
          value: "font-family: 'BIZ UDPMincho', serif;",
          label: 'yagish明朝'
        },
        {
          value: "font-family: 'DotGothic16', sans-serif;",
          label: 'ドットゴシック16'
        },
        {
          value: "font-family: 'Kiwi Maru', serif;",
          label: 'Kiwi Maru'
        },
        {
          value: "font-family: 'Klee One', cursive;",
          label: 'Klee One'
        },
        {
          value: "font-family: 'Kosugi', sans-serif;",
          label: 'Kosugi'
        },
        {
          value: "font-family: 'Zen Kurenaido', sans-serif;",
          label: 'Zen Kurenaido'
        }
      ],
      fontNames: [
        {
          value: "font-family: 'Noto Sans JP', sans-serif;",
          label: 'Noto Sans JP'
        },
        {
          value: "font-family: 'Noto Serif JP', serif;",
          label: 'Noto Serif JP'
        },
        {
          value: "font-family: 'Zen Maru Gothic', sans-serif;",
          label: 'yagishゴシック'
        },
        {
          value: "font-family: 'BIZ UDPMincho', serif;",
          label: 'yagish明朝'
        },
        {
          value: "font-family: 'DotGothic16', sans-serif;",
          label: 'ドットゴシック16'
        },
        {
          value: "font-family: 'Kiwi Maru', serif;",
          label: 'Kiwi Maru'
        },
        {
          value: "font-family: 'Klee One', cursive;",
          label: 'Klee One'
        },
        {
          value: "font-family: 'Kosugi', sans-serif;",
          label: 'Kosugi'
        },
        {
          value: "font-family: 'Zen Kurenaido', sans-serif;",
          label: 'Zen Kurenaido'
        }
      ]
    }
  },
  computed: {
    previewErrors: function () {
      if (!this.previewFormat || !this.previewFormat.errorMessages) return {}
      return this.previewFormat.errorMessages
    },
    optionItems: function () {
      if (!this.previewFormat || !this.previewFormat.optionItems) return {}
      return this.previewFormat.optionItems
    },
    isMynabi: function () {
      return (this.$yagi.isFromMynabi === 1)
    },
    getMode: function () {
      return process.env.VUE_APP_MODE
    }
  },
  methods: {
    setEducationalBackgrounds: function (historyList) {
      this.formatData.educationalHistories = []
      // 常に先頭から追加
      let index = 0
      for (const key in historyList) {
        const item = historyList[key]
        this.addEducationalHistory(index++, {
          year: item.year,
          month: item.month,
          description: item.desc
        })
      }
    },
    addExampleSentences: function (selectedSentences, modal) {
      const tArea = this.$refs.yourTextarea
      const startPos = tArea.selectionStart
      const endPos = tArea.selectionEnd
      const tmpStr = tArea.value
      console.error(tArea)
      console.error(startPos)
      this.formatData.reasonNew = tmpStr.substring(0, startPos) + selectedSentences + tmpStr.substring(endPos, tmpStr.length)
      modal.hide('reason-dialog')
    },
    setJobHistories: function (historyList) {
      // 先頭から追加
      for (const key in historyList) {
        const item = historyList[key]
        this.addJobHistory(null, {
          year: item.year,
          month: item.month,
          description: item.desc
        })
      }
    },
    resetEducationalBackgrounds: function () {
      this.formatData.educationalHistories = []
    },
    resetJobHistories: function () {
      this.formatData.jobHistories = []
    },
    createHistoryItem: function (columns) {
      if (!columns) columns = {}
      return new HistoryData(columns.year, columns.month, columns.description)
    },
    addHistory: function (historyList, index, refId, columns) {
      const newHistoryItem = this.createHistoryItem(columns)
      console.error(historyList)
      if (historyList == null) {
        historyList = []
      }
      if (typeof index === 'number') {
        historyList.splice(index, 0, newHistoryItem)
      } else {
        historyList.push(newHistoryItem)
      }
    },
    historySort: function (a, b) {
      let aYear = Number(a.year)
      let aMonth = Number(a.month)
      let bYear = Number(b.year)
      let bMonth = Number(b.month)
      if (aYear === bYear && aMonth === bMonth) {
        return 0
      }
      // 空欄は一番下に
      if (!aYear) aYear = 9999
      if (!aMonth) aMonth = 99
      if (!bYear) bYear = 9999
      if (!bMonth) bMonth = 99
      if (aYear > bYear) {
        return 1
      } else if (aYear < bYear) {
        return -1
      }
      if (aMonth > bMonth) {
        return 1
      } else if (aMonth < bMonth) {
        return -1
      }
      console.log('historySort failed')
      return 0
    },
    sortHistory: function (historyList) {
      // copy and sort
      return historyList.slice().sort(this.historySort)
    },
    addEducationalHistory: function (index, columns) {
      if (this.formatData.educationalHistories == null) {
        this.$set(this.formatData, 'educationalHistories', [])
      }
      this.addHistory(this.formatData.educationalHistories, index, 'EducationalHistory_', columns)
    },
    moveEducationalHistory: function (params) {
      this.moveHistory(this.formatData.educationalHistories, params)
    },
    addJobHistory: function (index, columns) {
      if (this.formatData.jobHistories == null) {
        this.$set(this.formatData, 'jobHistories', [])
      }
      this.addHistory(this.formatData.jobHistories, index, 'JobHistory_', columns)
    },
    moveJobHistory: function (params) {
      this.moveHistory(this.formatData.jobHistories, params)
    },
    addLicenseHistory: function (index, columns) {
      if (this.formatData.licenseHistories == null) {
        this.$set(this.formatData, 'licenseHistories', [])
      }
      this.addHistory(this.formatData.licenseHistories, index, 'LicenseHistory_', columns)
    },
    moveLicenseHistory: function (params) {
      this.moveHistory(this.formatData.licenseHistories, params)
    },
    moveHistory: function (historyList, params) {
      const fromIndex = params.index
      const to = params.to
      if (fromIndex === 0 && to === 'up') {
        console.log('first item skip')
        return
      }
      if (fromIndex + 1 === historyList.length && to === 'down') {
        console.log('last item skip')
        return
      }
      if (to === 'up') {
        historyList.splice(fromIndex - 1, 2, historyList[fromIndex], historyList[fromIndex - 1])
      } else if (to === 'down') {
        historyList.splice(fromIndex, 2, historyList[fromIndex + 1], historyList[fromIndex])
      } else {
        console.log('param "to" must be "up" or "down"')
      }
    },
    deleteEducationalHistory: function (index) {
      this.formatData.educationalHistories.splice(index, 1)
    },
    deleteJobHistory: function (index) {
      this.formatData.jobHistories.splice(index, 1)
    },
    deleteLicenseHistory: function (index) {
      this.formatData.licenseHistories.splice(index, 1)
    },
    activateHistoryItem: function (id) {
      this.activeHistoryItem = id
      const element = document.getElementById(id)
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        })
      }
    },
    deactivateHistoryItem: function () {
      this.activeHistoryItem = ''
    },
    dataChanged: function () {
      this.mailPdfEnabled = true
      this.downloadPdfEnabled = true
    }
  },
  watch: {
    'formatData.createDate': function (newValue, oldValue) {
      this.formatData.writeDate = this.$formLib.dateFormat(newValue, 'yyyy年 m月 d日')
    }
  },
  created: function () {
    const nowdate = new Date()
    const date1 = new Date('2023/05/27 00:00:00')
    const date2 = new Date('2023/05/28 23:59:59')
    if (nowdate > date1 && nowdate < date2) {
      this.isWeekEndFlag = true
    } else {
      this.isWeekEndFlag = false
    }
    if (this.getMode != 'production') {
      this.isWeekEndFlag = true
    }
  },
  beforeMount: function () {
    if (this.formatData.createDate === null) {
      this.formatData.createDate = this.$formLib.getToday()
    }
    if (this.formatId === 'rirekisho_job_new') {
      this.textareaMinRows = 10
      this.reasonLabel = '自己PR・ゼミ研究・得意科目・志望動機・特技・アピールポイントなど。書き方に困ったときは例文を元に編集してみましょう'
    }
    if (this.formatId === 'rirekisho_job_new_single') {
      this.textareaMinRows = 6
      this.reasonLabel = '自己PR・ゼミ研究・得意科目・志望動機・特技・アピールポイントなど。書き方に困ったときは例文を元に編集してみましょう'
    }
    this.$eventHub.$on('deactivate-history-item', this.deactivateHistoryItem)
    this.$eventHub.$on('basic-data-changed', this.dataChanged)
    this.$eventHub.$on('format-data-changed', this.dataChanged)
  },
  destroyed: function () {
    this.$eventHub.$off('deactivate-history-item', this.deactivateHistoryItem)
    this.$eventHub.$off('basic-data-changed', this.dataChanged)
    this.$eventHub.$off('format-data-changed', this.dataChanged)
  }
}
</script>
